import React from 'react';
import {observer} from 'mobx-react';
import AbTestStore, {ABTestKeys} from '../../global/store/ab-test.store';
import s from '../s';

declare var __normal_ship_text: string;
declare var __fast_ship_text: string;
declare var __fast_ship_text_mobile: string;

@observer
export default class ProductShipping extends React.Component {
    render() {
        return (
            <div>
                <div
                    className="prod-sub-header toggle-bs"
                    role="button"
                    tabIndex={0}
                    data-bs-toggle="collapse"
                    data-bs-target="#shipping"
                    aria-expanded={false}
                    aria-controls="shipping"
                >
                    Shipping
                </div>
                <div
                    id="shipping"
                    className="collapse show plh"
                >
                    {AbTestStore.ABIsVariant(ABTestKeys.prod_shipping, 1) && !__fast_ship_text && <div>Get it by {__normal_ship_text} if you purchase today. Options to purchase with expedited shipping as well.</div>}
                    {AbTestStore.ABIsVariant(ABTestKeys.prod_shipping, 1) && __fast_ship_text && <div>This best-selling item ships in 2-3 days. Get it by {__fast_ship_text} if you purchase today.</div>}
                    {AbTestStore.ABIsVariant(ABTestKeys.prod_shipping, 2) && <div>Ships within 5-7 business days - anywhere in the US. We can also ship APO, FPO, and internationally.</div>}
                </div>
            </div>
        );
    }
}
